<app-system-message></app-system-message>

<div [ngClass]="theme.getThemeClass()" class="container-fluido">
  <div [ngClass]="theme.getThemeClass()" class="card bg-light">
    <article class="card-body mx-auto article">
      <h4 class="card-title mt-0 text-center">
        {{ 'costEdit.title' | translate }}
      </h4>

      <form
        #costForm="ngForm"
        (ngSubmit)="onSubmit(!!costForm.valid)"
        novalidate
      >
        <div class="mb-4">
          <label class="only-label-display client-legal-name">{{ clientLegalName }}</label>
        </div>

        <div class="mb-3">
          <label class="label-spacer device-count-label">
            {{ 'costEdit.deviceCount' | translate }}
          </label>
          <div class="only-label-display device-count-value">{{ form.device_count }}</div>
        </div>

        <div class="mb-3">
          <label class="label-spacer">
            {{ 'costEdit.serviceFee' | translate }}
          </label>
          <div class="input-group">
            <span class="input-group-text">$</span>
            <input
              type="text"
              inputmode="decimal"
              class="form-control"
              name="service_fee"
              #serviceFee="ngModel"
              [(ngModel)]="form.service_fee"
              (keydown)="onFeeKeydown($event)"
              (paste)="onFeePaste($event)"
              (blur)="onFeeBlur('service_fee')"
              [ngClass]="theme.getThemeClass()"
            />
          </div>
        </div>

        <div class="mb-3">
          <label class="label-spacer">
            {{ 'costEdit.subscriptionFee' | translate }}
          </label>
          <div class="input-group">
            <span class="input-group-text">$</span>
            <input
              type="text"
              inputmode="decimal"
              class="form-control"
              name="subscription_fee"
              #subscriptionFee="ngModel"
              [(ngModel)]="form.subscription_fee"
              (keydown)="onFeeKeydown($event)"
              (paste)="onFeePaste($event)"
              (blur)="onFeeBlur('subscription_fee')"
              [ngClass]="theme.getThemeClass()"
            />
          </div>
        </div>

        <div class="mb-3">
          <label class="label-spacer">
            {{ 'costEdit.deviceFee' | translate }}
          </label>
          <div class="input-group">
            <span class="input-group-text">$</span>
            <input
              type="text"
              inputmode="decimal"
              class="form-control"
              name="device_fee"
              #deviceFee="ngModel"
              [(ngModel)]="form.device_fee"
              (keydown)="onFeeKeydown($event)"
              (paste)="onFeePaste($event)"
              (blur)="onFeeBlur('device_fee')"
              [ngClass]="theme.getThemeClass()"
            />
          </div>
        </div>

        <div class="mb-3">
          <label class="label-spacer">
            {{ 'costEdit.additionalFee' | translate }}
          </label>
          <div class="input-group">
            <span class="input-group-text">$</span>
            <input
              type="text"
              inputmode="decimal"
              class="form-control"
              name="additional_fee"
              #additionalFee="ngModel"
              [(ngModel)]="form.additional_fee"
              (keydown)="onFeeKeydown($event)"
              (paste)="onFeePaste($event)"
              (blur)="onFeeBlur('additional_fee')"
              [ngClass]="theme.getThemeClass()"
            />
          </div>
        </div>

        <div class="form-group displayFlex">
          <button
            type="button"
            class="btn btn-primary btn-block btnCancel fixed-size"
            [ngClass]="theme.getThemeClass()"
            (click)="cancel()"
          >
            {{ 'clientcreateFormBtnCancel' | translate }}
          </button>
          <button
            type="button"
            class="btn btn-primaryy btn-block btnCreate fixed-size red"
            [disabled]="isDeleting || isSubmitting"
            [ngClass]="theme.getThemeClass()"
            (click)="openDeleteConfirm()"
          >
            @if (!isDeleting) {<span>{{ 'delete' | translate }}</span>}
            @if (isDeleting) {
              <div class="spinner-border spinner-position spinner-button" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            }
          </button>
          <button
            type="submit"
            class="btn btn-primary btn-block btnCreate fixed-size"
            [disabled]="!costForm.valid || isSubmitting"
            [ngClass]="theme.getThemeClass()"
          >
            @if (!isSubmitting) {<span>{{ 'save' | translate }}</span>}
            @if (isSubmitting) {
              <div class="spinner-border spinner-position spinner-button" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            }
          </button>
        </div>
      </form>
    </article>
  </div>
</div>

@if (showDeleteConfirm) {
  <div class="confirm-overlay" (click)="cancelDelete()"></div>
  <div class="confirm-dialog" [ngClass]="theme.getThemeClass()">
    <div class="confirm-message">
      {{ 'costEdit.confirmDelete' | translate }}
    </div>
    <div class="confirm-actions">
      <button class="btn btnCancel fixed-size" (click)="cancelDelete()">
        {{ 'clientcreateFormBtnCancel' | translate }}
      </button>
      <button class="btn btnCreate fixed-size red" (click)="confirmDelete()">
        {{ 'delete' | translate }}
      </button>
    </div>
  </div>
}
